export default {
  getAuthenticationConfiguration() {
    return fetch('/authentication/configuration').then(it => it.json())
  }
}
